import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { Dimension } from '../../../../../features/dimension/types/Dimension'
import DimensionTreeSelect from '../../../../../features/dimension/components/DimensionTreeSelect'
import { useLegalMoveTargets } from '../hooks/useLegalMoveTargets'
import { useDimensionGridActions } from '../hooks/useDimensionGridActions'

interface DimensionMoveModalProps {
  open: boolean
  flatList: Dimension[]
  dimensionIds: string[]
  onClose: () => void
}

const ROOT_VALUE = '__root__'

const DimensionMoveModal: React.FC<DimensionMoveModalProps> = ({ open, flatList, dimensionIds, onClose }) => {
  const { t } = useTranslation()
  const { treeData } = useLegalMoveTargets(flatList, dimensionIds)
  const { moveUnder, isReordering } = useDimensionGridActions()
  const [targetId, setTargetId] = useState<string | undefined>(undefined)

  const handleConfirm = async () => {
    if (!targetId) return
    await moveUnder(flatList, dimensionIds, targetId === ROOT_VALUE ? null : targetId)
    setTargetId(undefined)
    onClose()
  }

  return (
    <Modal
      title={t('dimensionsPage:moveModalTitle')}
      open={open}
      onCancel={onClose}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('global:cancel')}
        </Button>,
        <Button
          key="ok"
          type="primary"
          disabled={!targetId}
          loading={isReordering}
          onClick={handleConfirm}
          style={{ marginLeft: 8 }}
        >
          {t('dimensionsPage:moveModalConfirm')}
        </Button>
      ]}
    >
      <DimensionTreeSelect
        style={{ width: '100%' }}
        treeData={[
          { dimensionId: ROOT_VALUE, name: t('dimensionsPage:moveModalRootOption'), id: -1, companyId: '', order: 0 },
          ...treeData
        ]}
        value={targetId}
        onChange={value => setTargetId(value as string)}
      />
    </Modal>
  )
}

export default DimensionMoveModal
